import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSync} from "@fortawesome/free-solid-svg-icons/faSync";
import React from "react";

interface BtnRefreshProps {
    refresh: () => void
}

const BtnRefresh = (
    props: BtnRefreshProps
) => {
    return (
        <button className="btn btn-refresh" type="button" onClick={props.refresh}>
            <FontAwesomeIcon icon={faSync} />&nbsp; Refresh
        </button>
    )
}

export default BtnRefresh;
